import { createReducer, on } from "@ngrx/store";
import { 
  setSurvey, 
  updateSurveyOptions, 
  updateSurveyResponse,
  loadSurveyQuestionsFromStorage,
  setRiasecScore
} from "@app/state/actions/surveys.action";
import { SurveyQuestion, SurveyResponse } from "@app/schemas/surveys";

function loadInitialSurveyQuestions(): SurveyQuestion[] {
  try {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem('survey_responses');
      return stored ? JSON.parse(stored) : [];
    }
    return [];
  } catch (error) {
    console.warn('Failed to load survey responses from localStorage:', error);
    return [];
  }
}

export const surveyReducer = createReducer(
  {},
  on(setSurvey, (_, action) => {
    return action.survey;
  })
);

const initialData: SurveyQuestion[] = loadInitialSurveyQuestions();
export const surveyQuestionsReducer = createReducer(
  initialData,
  on(updateSurveyOptions, (state, action) => {
    const updatedState = [...state];
    const questIndex = updatedState.findIndex(e => e.id == action.question_id);
    if (questIndex >= 0) {
      updatedState[questIndex] = action.question;
    } else {
      updatedState.push(action.question);
    }
    return updatedState;
  }),
  on(loadSurveyQuestionsFromStorage, (_, action) => {
    return action.questions;
  })
)

function loadInitialUserResponses(): SurveyResponse[] {
  try {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem('survey_user_responses');
      return stored ? JSON.parse(stored) : [];
    }
    return [];
  } catch (error) {
    console.warn('Failed to load user responses from localStorage:', error);
    return [];
  }
}

const initialResponse: SurveyResponse[] = loadInitialUserResponses();
export const surveyResponseReducer = createReducer(
  initialResponse,
  on(updateSurveyResponse, (state, action) => {
    if (action.response.length === 0) return state;
    const questionId = action.response[0].question_id;
    const filtered = state.filter(r => r.question_id !== questionId);
    return [...filtered, ...action.response];
  }),
);

export const riasecScoreReducer = createReducer(
  null,
  on(setRiasecScore, (_, action) => action.riasecScore),
);